import { mstrService } from '@/projects/platform/services/mstr-service';
import MstrWrapper from '@/core/wrappers/mstr-wrapper';

export default function MstrLiveSalesDashboards() {
    return (<MstrWrapper getReport={mstrService.getLiveSalesReport} />);
}